import "./style.scss";
import { FC, useState } from "react";
import { IFormApplicationProps } from "@/src/types/applyOnline";
import FormApplicationDopInfo from "./SubComponents/FormApplicationDopInfo";
import FormApplicationProgram from "./SubComponents/FormApplicationProgram";
import FormApplicationFast from "./SubComponents/FormApplicationFast";

const FormApplication: FC<IFormApplicationProps> = (props) => {
  const { register, control, errors, handleSubmit, setValue, selectedFilesMap, setSelectedFilesMap, isSubmitDisabled } = props;

  const [fileModalIsActive, setFileModalIsActive] = useState<boolean>(false);

  const handleClickDocument = (action: "open" | "close") => {
    setFileModalIsActive(action === "open");
    document.body.classList.toggle("hidden", action === "open");
  };

  const handleFocus = (el: string) => {
    const allStepTitles = document.querySelectorAll(".apply-online-step-title");
    allStepTitles.forEach((el) => el.classList.remove("active"));

    const targetStepTitle = document.querySelector(`.apply-online-step-title.${el}`);
    const targetStep = document.querySelector(`.apply-online-step-point.${el}`);
    if (targetStepTitle && targetStep) {
      targetStepTitle.classList.add("active");
      targetStep.classList.add("isWasEmpty");
    }
  };

  return (
    <div className="form-application">
      <FormApplicationFast register={register} control={control} errors={errors} handleFocus={() => handleFocus("one")} />
      <FormApplicationDopInfo register={register} control={control} errors={errors} handleFocus={() => handleFocus("two")} />
      <FormApplicationProgram register={register} control={control} errors={errors} handleFocus={() => handleFocus("three")} />
    </div>
  );
};

export default FormApplication;
